<div ngbDropdownItem>
  <div class="d-flex justify-content-between">
    <span *ngIf="notificationNumber; else noNotifications"
      >{{ notificationNumber }} new notification{{ notificationNumber > 1 ? 's' : '' }}</span
    >
    <ng-container *ngIf="informationalNotificationsNumber > 0">
      <button data-test-id="dismiss-all-button" class="btn btn-sm btn-secondary" (click)="onDismissAll()">
        Dismiss all
      </button>
    </ng-container>
  </div>
  <ng-template #noNotifications>
    <div class="text-center">
      <span>{{ 'NO_NOTIFICATIONS' | translate }}</span>
    </div>
  </ng-template>
</div>
